export class RequestFileLoad{
    constructor(
        public fileBase64? : string,
        public fileName? : string,
        public fileExtension? : string
    ){}
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/request-file-load.model.ts